import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import { Pencil, Plus, DownloadSimple } from "@phosphor-icons/react/dist/ssr";
import {
  Trash,
  PaperPlaneTilt,
  UserCheck,
  Prohibit,
  DotsThreeOutlineVertical,
  Key,
} from "@phosphor-icons/react";
const tableConfig: FinalTableConfig = {
      index: null,
      actions: [
        {
          name: TableAction.EXPORT,
          label: 'export',
          showLabel: true,
          allowed: true,
          show: true,
          action: null,
          variant: 'secondary',
          icon: <DownloadSimple size={20} />,
        },
        {
          name: TableAction.CREATE,
          label: 'create',
          showLabel: true,
          allowed: true,
          show: true,
          action: null,
          variant: 'primary',
          icon: <Plus size={20} />,
        },
      ],
      rowActions: [
        {
          name: RowAction.EDIT,
          label: 'edit',
          icon: <Pencil size={20} />,
          allowed: true,
          show: true,
          action: (element: any) => {
            console.log('edit', element);
          }
        },
        {
          name: "more",
          label: "more",
          allowed: true,
          show: true,
          icon: <DotsThreeOutlineVertical size={20} />,
          actions: [
            {
              name: "change-password",
              label: "change_password",
              icon: <Key size={20} />,
              allowed: true,
              show: true,
              action: (element: any) => {
                console.log("change-password", element);
              },
            },
            {
              name: "reset-password-email",
              label: "send_reset_password",
              icon: <PaperPlaneTilt size={20} />,
              allowed: true,
              show: true,
              data: "email",
              action: (element: any) => {
                console.log("reset-password-email", element);
              },
            },
            {
              name: "active-account",
              label: "active_account",
              icon: <UserCheck size={20} />,
              allowed: true,
              show: (element: any, user: any) => {
                return element.status !== 1;
              },
              data: null,
              action: (element: any) => {
                console.log("active-account", element);
              },
            },
            {
              name: "disable-account",
              label: "disable_account",
              icon: <Prohibit size={20} />,
              allowed: true,
              show: (element: any, user: any) => {
                return element.status === 1;
              },
              data: null,
              action: (element: any) => {
                console.log("disable-account", element);
              },
            },
            {
              name: RowAction.DELETE,
              label: "delete",
              icon: <Trash size={20} />,
              allowed: true,
              show: true,
              action: (element: any) => {
                console.log("delete", element);
              },
            },
          ],
        },
      ],
      rowConfiguration: {
        class: (element: any) => {
          return null;
        }
      },
      columns: [
        {
          name: 'id',
          label: '#',
          key: 'id',
          type: 'number',
          show: true,
          allowOrder: true,
        },
        {
          name: 'name',
          label: 'name',
          key: 'name',
          type: 'string',
          show: true,
          allowOrder: true,
        },
        {
          name: 'surnames',
          label: 'surnames',
          key: 'surnames',
          type: 'string',
          show: true,
          allowOrder: true,
        },
        {
          name: 'email',
          label: 'Email',
          key: 'email',
          type: 'string',
          show: true,
          allowOrder: true,
        },
        {
          name: 'role',
          label: 'role',
          key: 'roles.0.name',
          type: 'translation',
          translation_prefix: 'user_role',
          show: true,
          allowOrder: true,
        }
      ],
      pagination: {
        enabled: true,
        back: true
    }
}
const getConfig: any = (functions: any) => {
    const {
      getFunction,
      indexFunction,
      initializeFunction,
      prepareRemoveFunction,
      exportFunction,
      prepareChangePasswordFunction,
      prepareResetPasswordFunction,
      prepareActiveOrDisableFunction,
    } = functions;
    tableConfig.actions[0].action = () => exportFunction();
    tableConfig.actions[1].action = () => initializeFunction();
    tableConfig.index = () => indexFunction();
    tableConfig.rowActions[0].action = (id: any) => getFunction(id);
    // more menu actions mapping
    tableConfig.rowActions[1].actions[0].action = (id: any) =>
      prepareChangePasswordFunction(id);
    tableConfig.rowActions[1].actions[1].action = (email: any) =>
      prepareResetPasswordFunction(email);
    tableConfig.rowActions[1].actions[2].action = (user: any) =>
      prepareActiveOrDisableFunction(user);
    tableConfig.rowActions[1].actions[3].action = (user: any) =>
      prepareActiveOrDisableFunction(user);
    tableConfig.rowActions[1].actions[4].action = (id: any) =>
      prepareRemoveFunction(id);
    return tableConfig;
}
export default getConfig;
